// 🔥 Force breakpoint manually (<=1023 = mobile)
const MOBILE_BREAKPOINT = 1023;

function isMobile() {
  return window.innerWidth <= MOBILE_BREAKPOINT;
}

// Custom media query (sync with above)
const mediaQueryCustom = window.matchMedia(`(max-width: ${MOBILE_BREAKPOINT}px)`);


// Accordion
class AccordionCustom extends HTMLElement {
  get details() {
    const details = this.querySelector('details');
    if (!(details instanceof HTMLDetailsElement)) throw new Error('Details element not found');
    return details;
  }

  get summary() {
    const summary = this.details.querySelector('summary');
    if (!(summary instanceof HTMLElement)) throw new Error('Summary element not found');
    return summary;
  }

  get #disableOnMobile() {
    return this.dataset.disableOnMobile === 'true';
  }

  get #disableOnDesktop() {
    return this.dataset.disableOnDesktop === 'true';
  }

  get #closeWithEscape() {
    return this.dataset.closeWithEscape === 'true';
  }

  #controller = new AbortController();

  connectedCallback() {
    const { signal } = this.#controller;

    this.#setDefaultOpenState();

    this.addEventListener('keydown', this.#handleKeyDown, { signal });
    this.summary.addEventListener('click', this.handleClick, { signal });

    // 🔥 Use custom media query instead of theme one
    mediaQueryCustom.addEventListener('change', this.#handleMediaQueryChange, { signal });
  }

  disconnectedCallback() {
    this.#controller.abort();
  }

  handleClick = (event) => {
    const isMobileView = isMobile();
    const isDesktopView = !isMobileView;

    if ((isMobileView && this.#disableOnMobile) || (isDesktopView && this.#disableOnDesktop)) {
      event.preventDefault();
      return;
    }
    const html = document.documentElement;

      const previous = html.style.scrollBehavior;

      html.style.scrollBehavior = 'auto';
    requestAnimationFrame(() => {
      // only when accordion is opened
      const prevAccordion = this
        .closest('accordion-custom')
        ?.previousElementSibling;

      if (prevAccordion?.matches('accordion-custom')) {
       const top =
        prevAccordion.getBoundingClientRect().top + window.scrollY;

      //alert(top);
      if (this.details.open) {
        const rect = this.offsetTop;
        const offset = window.scrollY + rect;

        window.scrollTo(0, top);
      }
      html.style.scrollBehavior = previous; 
      }
      //alert(this.closest('accordion-custom')?.previousElementSibling('accordion-custom'));
      
    });
  };

  #handleMediaQueryChange = () => {
    this.#setDefaultOpenState();
  };

  #setDefaultOpenState() {
    const isMobileView = isMobile();

    this.details.open =
      (isMobileView && this.hasAttribute('open-by-default-on-mobile')) ||
      (!isMobileView && this.hasAttribute('open-by-default-on-desktop'));
  }

  #handleKeyDown = (event) => {
    if (event.key === 'Escape' && this.#closeWithEscape) {
      event.preventDefault();
      this.details.open = false;
      this.summary.focus();
    }
  };
}

if (!customElements.get('accordion-custom')) {
  customElements.define('accordion-custom', AccordionCustom);
}